import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BlogService } from '../blog.service';

export const useGetBlogPosts = (
	params: Blog.FindBlogPostsQuery,
	options?: Omit<
		UseQueryOptions<Blog.PaginatedBlogPostList, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: [
			'blog-posts',
			params.page,
			params.limit,
			params.search,
			params.sort,
			params.sort_direction,
		],
		queryFn: () => BlogService.getAll(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetBlogPostBySlug = (
	slug: string,
	options?: Omit<
		UseQueryOptions<Blog.BlogPost, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['blog-post-slug', slug],
		queryFn: () => BlogService.getBySlug(slug),
		refetchOnWindowFocus: false,
		enabled: !!slug,
		...options,
	});
};

export const useGetBlogPost = (
	id: string,
	options?: Omit<
		UseQueryOptions<Blog.BlogPost, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['blog-post', id],
		queryFn: () => BlogService.getById(id),
		refetchOnWindowFocus: false,
		enabled: !!id,
		...options,
	});
};
